var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-auth',_vm._b({staticClass:"m-auth",attrs:{"type":"modern"},on:{"back":_vm.backToLogin}},'y-auth',{ ..._vm.props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }